import { render, staticRenderFns } from "./CrewPriceListSection.vue?vue&type=template&id=999b59c8&"
import script from "./CrewPriceListSection.vue?vue&type=script&lang=js&"
export * from "./CrewPriceListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports